export interface IStoreConfig {
  _id?: string;
  store_id?: number;
  // crm_bonus_token: string;
  crm_bonus_cod: string;

  popup_in_cart_show: boolean;
  popup_progress_bar_show: boolean;

  popup_title: string;
  popup_text_not_logged: string;
  popup_text_not_logged_cta: string;
  popup_text_not_bonus: string;
  popup_text_not_phone: string;
  popup_text_not_phone_cta: string;
  popup_text_have_bonus: string;
  popup_progress_bar_text: string;

  popup_bg_color: string;
  popup_title_color: string;
  popup_text_color: string;
  popup_primary_color: string;
  popup_success_color: string;

  black_list_products: { [key: number]: string };
  black_list_category: { [key: number]: string };
  is_active: boolean;

  ns_promotion_id?: string;
  block_products_with_discount: boolean;
  block_bonus_with_coupon: boolean;
  allow_resend_whatsapp_pin?: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export const defaultStoreConfig: IStoreConfig = {
  // crm_bonus_token: '',
  crm_bonus_cod: '',

  popup_in_cart_show: true,
  popup_progress_bar_show: true,

  popup_title: 'Giftback',
  popup_text_not_logged: 'Você precisa estar logado para verificar o seu bônus',
  popup_text_not_logged_cta: 'Fazer login',
  popup_text_not_bonus: 'Você não possui bônus nessa compra.',
  popup_text_not_phone:
    'Você precisa ter um telefone cadastrado para usar seu bônus',
  popup_text_not_phone_cta: 'Adicionar um telefone',
  popup_text_have_bonus: 'Você pode resgatar <b>{bonus}</b> para esta compra',
  popup_progress_bar_text:
    'Restam {valor} para resgatar o total de {total} em bonus',

  popup_bg_color: '#FFFFFF',
  popup_title_color: '#000000',
  popup_text_color: '#000000',
  popup_primary_color: '#007BFF',
  popup_success_color: '#28A745',

  black_list_products: {},
  black_list_category: {},
  is_active: true,

  ns_promotion_id: '',
  block_products_with_discount: false,
  block_bonus_with_coupon: false,
  allow_resend_whatsapp_pin: false,
};
